import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../pages/Board/NoticeDetail.scss";
import DOMPurify from "dompurify";

export default function MyTabDetail({ menuData, category }) {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [prevData, setPrevData] = useState([]);
  // const [submitFiles, setSubmitFiles] = useState([]);
  // const getSubmitFiles = async () => {
  //   try {
  //     const res = await axios.get("/api/task-apply-form-attrs", {
  //       params: {
  //         targetId: prevData.taskGroupId,
  //         applyProcessId: prevData.id,
  //         confVesrion: prevData.confVersion,
  //       },
  //     });
  //     setSubmitFiles(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const [showModal, setShowModal] = useState(false);
  const [stopType, setStopType] = useState("");
  const [stopReason, setStopReason] = useState("");
  const [stopDate, setStopDate] = useState("");

  const onChangeHandler = (event) => {
    if (event.target.name === "select1") {
      setStopType(event.target.value);
    }
    if (event.target.name === "textarea1") {
      setStopReason(event.target.value);
    }
  };
  const getPrevData = async () => {
    try {
      const response = await axios.get(`/api/apply-proc/${state}`);
      setPrevData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const taskGroupsHandler = (el, e) => async () => {
    // 신청 Form data 가져오기 없는경우 return
    // const response = await axios.get("/api/task-apply-form", {
    //   params: {
    //     taskGroupId: el.id,
    //   },
    // });
    // if (response.data.length === 0) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "오류",
    //     text: "데이터가없습니다,관리자에 문의하세요",
    //     confirmButtonColor: "dodgerBlue",
    //   });
    //   return;
    // } else {
    
    /* issue-172 : 제약 조건 해제 요청으로 소스 수정*/
    if (!el || el !== null || el !== undefined) {
      el.beforeId = e.id;
      let tempObj = {};
      tempObj.id = [el];
      navigate("/request/institution", { state: tempObj });
    } else {
       Swal.fire({
        icon: "error",
        title: "오류",
        text: "데이터가없습니다,관리자에 문의하세요",
        confirmButtonColor: "dodgerBlue",
      });
    }
   
    /** issue-172 : 재약 조건 해제 요청으로 소스 삭제 
   
    if (
      el.typeName === "재발급" ||
      el.typeName === "추가" ||
      el.typeName === "변경"
    ) {
      el.beforeId = e.id;
      let tempObj = {};
      tempObj.id = [el];
      navigate("/request/institution", { state: tempObj });
    } else if (el.typeName === "정기심사" && !el.workflowName.includes("기술")) {
      // 정기심사 인증일 기준 1년 후 3개월 이전부터 가능
      // 인증 기준 마지막 해 제외 1년씩 3개월 전인 경우는 오류, 인증 총 3회 인정 1회

      let today = moment();
      let expiredDay = moment(e.expiredDate).subtract(3, "months");

      if (!moment(expiredDay).isSameOrBefore(today)) {
        el.beforeId = e.id;
        let tempObj = {};
        tempObj.id = [el];
        navigate("/request/institution", { state: tempObj });
      } else {
        Swal.fire({
          icon: "error",
          title: "오류",
          html: `정기심사는 1년기준 3개월 이전에만 신청가능합니다<br/>(인정-2년기준)`,
          confirmButtonColor: "dodgerBlue",
        });
      }
    }
    // 재평가 expired date 기준 7개월전부터 신청가능
    else if (el.typeName === "재평가") {
      let today = moment();
      let expiredDay = moment(e.expiredDate).subtract(7, "months");

      if (!moment(expiredDay).isSameOrBefore(today)) {
        el.beforeId = e.id;
        let tempObj = {};
        tempObj.id = [el];
        navigate("/request/institution", { state: tempObj });
      } else {
        Swal.fire({
          icon: "error",
          title: "오류",
          html: `재평가는 만료일(${e.expiredDate})기준<br/> 7개월이전에만 신청가능합니다`,
          confirmButtonColor: "dodgerBlue",
        });
      }
    } else {
      // 만료일 기준 3개월 이전 신청불가 (재평가)
      let today = moment();
      if (today.diff(e.expiredDate, "month") >= -3) {
        el.beforeId = e.id;
        let tempObj = {};
        tempObj.id = [el];
        navigate("/request/institution", { state: tempObj });
      } else {
        Swal.fire({
          icon: "error",
          title: "오류",
          html: `정기심사는 만료일(${e.expiredDate})기준<br/> 3개월이전에만 신청가능합니다`,
          confirmButtonColor: "dodgerBlue",
        });
      }
    }
    // }
    */
  };
  const closeModal = () => {
    setShowModal(false);
    setStopDate("");
    setStopType("");
    setStopReason("");
  };
  const stopModalOpen = () => {
    if (prevData.stopCnt < 2) {
      setShowModal(true);
    } else {
      Swal.fire({
        icon: "error",
        title: "오류",
        text: "중지신청은 2회이상 신청불가합니다",
        confirmButtonColor: "dodgerBlue",
      });
    }
  };
  const inputHandler = (event) => {
    setStopDate(event.target.value);
  };
  const stopApply = async () => {
    let today = moment();
    if (stopReason === "" || stopType === "") {
      Swal.fire({
        icon: "error",
        title: "오류",
        text: "입력정보를 확인해주세요",
        confirmButtonColor: "dodgerBlue",
      });
      return;
    } else {
      if (prevData.state === 10) {
        if (
          stopDate === "" ||
          today.diff(stopDate, "month") <= -6 ||
          today.diff(stopDate, "day") > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "오류",
            text: "중지기간을 확인해주세요",
            confirmButtonColor: "dodgerBlue",
          });
          return;
        } else {
          try {
            const response = await axios.post(
              `/api/apply-proc/requestData/${prevData.id}`,
              {
                type: stopType,
                opinion: stopReason,
                limitDate: stopDate,
              }
            );

            setShowModal(false);
            setStopDate("");
            setStopType("");
            setStopReason("");
            if (response.data === 0) {
              Swal.fire({
                icon: "success",
                title: "완료",
                text: "처리담당자에게 메일이 발송되었습니다",
                confirmButtonColor: "dodgerBlue",
                iconColor: "dodgerBlue",
              });
            }
            if (response.data === 1) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "업로드파일을 확인해주세요",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 2) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "중지신청중입니다",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 3) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "신청서를 다시확인해주세요",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 4) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "신청서가 진행중인 상태가 아닙니다",
                confirmButtonColor: "dodgerBlue",
              });
            }
          } catch (err) {
            setShowModal(false);
            setStopDate("");
            setStopType("");
            setStopReason("");
            console.log(err);
          }
        }
      } else {
        if (today.diff(prevData.limitDate, "day") >= 0) {
          Swal.fire({
            icon: "error",
            title: "오류",
            text: "중지만료일 1개월전에만 가능합니다",
            confirmButtonColor: "dodgerBlue",
          });
        } else {
          try {
            const response = await axios.post(
              `/api/apply-proc/requestData/${prevData.id}`,
              {
                type: 3,
                opinion: stopReason,
              }
            );

            setShowModal(false);
            setStopDate("");
            setStopType("");
            setStopReason("");
            if (response.data === 0) {
              Swal.fire({
                icon: "success",
                title: "완료",
                text: "처리담당자에게 메일이 발송되었습니다",
                confirmButtonColor: "dodgerBlue",
                iconColor: "dodgerBlue",
              });
            }
            if (response.data === 1) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "업로드파일을 확인해주세요",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 2) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "중지신청중입니다",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 3) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "신청서를 다시확인해주세요",
                confirmButtonColor: "dodgerBlue",
              });
            }
            if (response.data === 4) {
              Swal.fire({
                icon: "error",
                title: "오류",
                text: "신청서가 진행중인 상태가 아닙니다",
                confirmButtonColor: "dodgerBlue",
              });
            }
          } catch (err) {
            setShowModal(false);
            setStopDate("");
            setStopType("");
            setStopReason("");
            console.log(err);
          }
        }
      }
    }
  };
  useEffect(() => {
    getPrevData();
    // getSubmitFiles();
  }, [state]);
  const detailBtn = () => {
    navigate("/stepper", { state: prevData });
  };
  return (
    <>
      {showModal === true ? (
        <div className="popup_bg_bbs " onClick={closeModal}>
          <div
            className="password_change "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>{prevData.state === 22 ? "중지▪재개 신청" : "취소 신청"}</h1>
              {prevData.state === 10 ? (
                <span style={{ fontSize: "0.9rem" }}>
                  중지신청횟수:{prevData.stopCnt}
                </span>
              ) : null}
            </div>
            <section className="customcenter_title_row">
              <div className="customcenter_title_col">
                <div
                  className="select_box select_box_first"
                  style={{ marginLeft: "50px", marginTop: "10px" }}
                >
                  <select name="select1" onChange={onChangeHandler}>
                    <label htmlFor="start" style={{ wordBreak: "keep-all" }}>
                      <b>중지기간입력:</b>
                    </label>
                    <option value="0">분야선택</option>
                    {prevData.state === 10 ? (
                      <>
                        <option value="4">중지</option>
                      </>
                    ) : (
                      <>
                        {prevData.state === 22 ? (
                          <>
                            <option value="6">중지재개신청</option>
                          </>
                        ) : (
                          <>
                            <option value="5">취소</option>
                          </>
                        )}
                      </>
                    )}
                  </select>
                  {prevData.state === 10 ? (
                    <>
                      <div className="input_wrap input_date">
                        <label
                          htmlFor="start"
                          style={{ wordBreak: "keep-all" }}
                        >
                          <b>중지기간입력:</b>
                        </label>
                        <input
                          id="start"
                          name="startDate"
                          value={stopDate}
                          onChange={inputHandler}
                          className="input_line"
                          type="date"
                        />
                      </div>
                      <h5 style={{ color: "red" }}>
                        현재신청일(당일)기준 6개월까지 중지신청 가능합니다
                      </h5>
                    </>
                  ) : null}
                </div>
              </div>
            </section>
            <div style={{ padding: "20px" }}>
              <div>
                <textarea
                  onChange={onChangeHandler}
                  name="textarea1"
                  style={{
                    width: "100%",
                    backgroundColor: "white",
                    margin: "1rem 0",
                    padding: "10px",
                    height: "200px",
                  }}
                  type="textarea"
                  placeholder="사유를 입력해주세요"
                />
              </div>
              <div style={{ display: "flex", gap: "3px" }}>
                <button
                  className="btn_none"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={closeModal}
                >
                  취소
                </button>
                <button
                  className="btn_color"
                  type="button"
                  style={{ width: "100%" }}
                  onClick={stopApply}
                >
                  신청
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="help_prev">
        <h1>신청정보</h1>
        <div className="help_prev_list_wrap">
          <ul className="help_prev_list">
            <li>
              <b>접수번호:</b> <span>{prevData.acceptNum}</span>
            </li>
            {prevData.state === 10 ? (
              <li>
                <b>인증번호:</b> <span>{prevData.qualificationNum}</span>
              </li>
            ) : null}

            <li>
              <b>접수일:</b> <span>{prevData.acceptDate}</span>
            </li>
            <li>
              <b>신청기관:</b> <span>{prevData.applicantName}</span>
            </li>
            {prevData?.prdName && (
              <li>
                <b>제품명:</b> <span>{prevData.prdName}</span>
              </li>
            )}
            {prevData?.modelName && (
              <li>
                <b>모델명:</b> <span>{prevData.modelName}</span>
              </li>
            )}
            {prevData?.addition?.length > 0
              ? prevData.addition.map((e) => {
                  return (
                    <>
                      {e.prdName && (
                        <li>
                          <b>추가제품명:</b> <span>{e.prdName}</span>
                        </li>
                      )}
                      {e.modelName && (
                        <li>
                          <b>추가모델명:</b> <span>{e.modelName}</span>
                        </li>
                      )}
                    </>
                  );
                })
              : null}
            <li>
              <b>진행단계:</b>{" "}
              <span>
                {prevData.state === 10 ? "인증완료" : <>{prevData.taskName}</>}
              </span>
            </li>

            <li>
              <button type="button" className="btn_color" onClick={detailBtn}>
                상세보기
              </button>

              {prevData.state === 10 && prevData.typeName === "신규" ? (
                <>
                  {menuData.map((el) => {
                    if (el.name === prevData.taskGroup?.workflowName) {
                      let testObj = el.taskGroups.filter(
                        (element) =>
                          element.type !== 1 &&
                          element.type !== 9 &&
                          element.type !== 7
                      );
                      const typeOrder = [
                        "상세보기",
                        "정기심사",
                        "재평가",
                        "추가",
                        "변경",
                        "재발급",
                        "중지",
                      ];

                      const sortedTestObj = testObj.sort((a, b) => {
                        const indexA = typeOrder.indexOf(a.typeName);
                        const indexB = typeOrder.indexOf(b.typeName);
                        return indexA - indexB;
                      });
                      return (
                        <>
                          {sortedTestObj.map((otherOne) => {
                            return (
                              <button
                                key={otherOne.id}
                                style={{
                                  marginLeft: "1vw",
                                  backgroundColor: "#687DE8",
                                  color: "white",
                                }}
                                type="button"
                                className="btn_white"
                                onClick={taskGroupsHandler(otherOne, prevData)}
                              >
                                {otherOne.typeName}
                              </button>
                            );
                          })}
                        </>
                      );
                    }
                  })}

                  <button
                    style={{
                      marginLeft: "1vw",
                      backgroundColor: "red",
                      color: "white",
                    }}
                    type="button"
                    className="btn_none"
                    onClick={() => setShowModal(true)}
                  >
                    중지
                  </button>
                </>
              ) : (
                <>
                  {prevData.state === 9 ||
                  prevData.state === 99 || // 이미 취소신청을 한 경우
                  prevData.taskGroup?.type === 9 ||
                  prevData.typeName === "정기심사" ? null : (
                    <button
                      type="button"
                      style={{
                        marginLeft: "1vw",
                        color: "white",
                        backgroundColor: "red",
                      }}
                      className="btn_none"
                      onClick={stopModalOpen}
                    >
                      {prevData.state === 22 ? "재개신청" : "취소신청"}
                    </button>
                  )}
                </>
              )}
            </li>
            {prevData.state === 9 || prevData.state === 99 ? (
              <li>
                <span style={{ color: "red", marginLeft: "5px" }}>
                  <b>
                    취소된 신청서입니다(
                    {prevData.updateAt.substring(0, 11).replace(/-/g, ".")})
                  </b>
                </span>
              </li>
            ) : null}
            {prevData.state === 22 ? (
              <>
                <li>
                  <span style={{ color: "red", marginLeft: "5px" }}>
                    <b>
                      효력정지된 신청서입니다 (효력정지일:
                      {prevData.updateAt.substring(0, 11).replace(/-/g, ".")})
                    </b>
                  </span>
                </li>
                <li>
                  <span style={{ color: "red", marginLeft: "5px" }}>
                    <b>
                      재개신청은 중지만료일 1개월전부터 가능합니다(중지만료일:
                      {prevData?.limitDate?.substring(0, 11).replace(/-/g, ".")}
                      )
                    </b>
                  </span>
                </li>
              </>
            ) : null}
          </ul>
          <ul className="help_prev_list">
            {prevData.applyFormValues?.map((e) => {
              const safeDescription = DOMPurify.sanitize(e.description);

              return (
                <li key={e.id}>
                  {e.parentItemName === null ? (
                    <b>{e.entryName}</b>
                  ) : (
                    <b>{e.parentItemName}</b>
                  )}{" "}
                  :<span dangerouslySetInnerHTML={{ __html: safeDescription }} />{" "}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
}
